<div class="bulk-container">
  <div class="header-row">
    <h2 class="title">Upload Excel File</h2>
    <button class="back-btn" (click)="goBack()">← Back</button>
  </div>

  <div class="upload-card">
    <div class="drag-area"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <img src="https://cdn-icons-png.flaticon.com/512/109/109612.png" class="upload-icon">
      <p class="drag-text">Drag & drop your file here</p>
      <p class="or-text">or</p>

      <label class="choose-btn">
        Choose File
        <input type="file" (change)="onFileSelect($event)">
      </label>
    </div>

    <div class="requirements">
      <p><strong>File Requirements:</strong></p>
      <ul>
        <li>Format: .xlsx or .xls</li>
        <li>Max Size: 5MB</li>
        <li>Max Records: 100</li>
      </ul>
    </div>

    <div class="file-preview" *ngIf="selectedFileName">
      <div>Selected File: <strong>{{ selectedFileName }}</strong></div>
      <div>Size: {{ (selectedFileSize / 1024 / 1024) | number:'1.2-2' }} MB</div>
      <div>Records: {{ selectedFileRecordCount }}</div>
      <div *ngIf="validationErrors.length">
        <ul>
          <li *ngFor="let err of validationErrors" style="color: #d9534f">{{ err }}</li>
        </ul>
      </div>
    </div>

    <div class="action-buttons">
      <button class="guide-btn" (click)="downloadFormatGuide()" [disabled]="false">Format Guide</button>
      <button class="upload-btn" (click)="uploadProcess()" [disabled]="!fileValid" [class.disabled]="!fileValid">
        Upload & Process
      </button>
    </div>
  </div>

  <div class="history-card">
    <h3>Upload History</h3>

    <table class="history-table">
      <thead>
        <tr>
          <th (click)="sortuser('transId')">ID</th>
          <th (click)="sortuser('fileName')">File Name</th>
          <th (click)="sortuser('date')">Date</th>
          <th (click)="sortuser('transactionStatus')">Status</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="paginateduser.length === 0">
          <td colspan="5" class="no-record">No matching records found</td>
        </tr>

        <tr *ngFor="let row of paginateduser">
          <td>{{ row.transId }}</td>
          <td>
            <span class="file"><i class="fa fa-file-excel-o"></i>
              {{ row.fileName }}</span>
          </td>
          <td class="date-time-box">
            <div class="date">{{ row.date | date:'yyyy-MM-dd' }}</div>
            <div class="time">{{ row.date | date:'HH:mm' }}</div>
          </td>
          <td>
            <span class="common_message" [ngClass]="{'status-success': row.transactionStatus === 'SUCCESS', 
                                                     'status-failed': row.transactionStatus == 'FAILED',
                                                     'status-progress': row.transactionStatus == 'IN_PROGRESS',
                                                     'status-submitted': row.transactionStatus == 'SUBMITTED'}">
              {{ row.transactionStatus }}
            </span>
          </td>
          <td class="action-col">
            <button class="icon-btn file-btn" (click)="viewReport(row)">
              <i class="fa fa-download"></i> File
            </button>

            <button class="icon-btn report-btn" (click)="viewDetails(row)">
              <i class="fa fa-eye"></i> Report
            </button>
          </td>

        </tr>
      </tbody>
    </table>

    <nav *ngIf="filtereduser.length > rowsPerPage2" class="pagination-controls">
      <span>Showing {{ getStartIndex() }} to {{ getEndIndex() }} of {{ filtereduser.length }} entries</span>

      <div class="pagination-buttons">
        <button class="page-btn" [disabled]="currentPage2 === 1"
          (click)="changePage2(currentPage2 - 1)">Previous</button>

        <ng-container *ngFor="let page of getPagesuser()">
          <button class="page-btn" [disabled]="currentPage2 === page || !isValidPage(page)"
            [class.active]="currentPage2 === page" (click)="isValidPage(page) && changePage2(page)">
            {{ page }}
          </button>
        </ng-container>

        <button class="page-btn" [disabled]="currentPage2 === totalPages2"
          (click)="changePage2(currentPage2 + 1)">Next</button>
      </div>
    </nav>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>